<template>
  <div class="problemDesContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="des">
        <template #title>
          <span>
            <img src="../../assets/svg/desIcon.svg" alt="" />
            问题描述
          </span>
        </template>
        <el-form :model="form" :rules="formRules" ref="descForm">
          <el-descriptions :column="3" border>
            <el-descriptions-item :span="6" v-bind="baseClassConfig">
              <template slot="label">
                <div class="labelDetail">
                  <p>故障现象描述</p>
                  <div>
                    <translate
                      :content="form.questionContent"
                      field="questionContentCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div class="translateDetail">
                <el-form-item prop="questionContent" v-if="!authStatus">
                  <el-input
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :disabled="authStatus"
                    @blur="inputBlur(form.questionContent, 'questionContent')"
                    v-model="form.questionContent"
                    type="textarea"
                    placeholder="请输入故障现象描述"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">
                  {{ form.questionContent }}
                </div>
                <div class="problemDesInfo">{{ form.questionContentCh }}</div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-form>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="重复性">{{
            problemDes.repeatability == 0 ? "一直存在" : "偶发"
          }}</el-descriptions-item>
          <el-descriptions-item
            label="有无超载"
            v-if="problemDes.carType == 1"
            >{{ problemDes.overload == 0 ? "有" : "无" }}</el-descriptions-item
          >
          <el-descriptions-item
            label="行驶工况"
            v-if="problemDes.carType == 1"
            >{{ problemDes.drivingCondition }}</el-descriptions-item
          >
          <el-descriptions-item
            label="行驶路况"
            v-if="problemDes.carType == 1"
            >{{ problemDes.roadCondition }}</el-descriptions-item
          >
          <el-descriptions-item
            label="天气情况"
            v-if="problemDes.carType == 1"
            >{{ problemDes.weatherCondition }}</el-descriptions-item
          >
          <el-descriptions-item
            label="加载情况"
            v-if="problemDes.carType == 1"
            >{{ problemDes.modificationStatus }}</el-descriptions-item
          >
          <el-descriptions-item
            label="临时措施"
            v-if="problemDes.temporaryMeasure?.solution.length > 0"
            >{{ problemDes.temporaryMeasure.solution }}</el-descriptions-item
          >
          <!-- <el-descriptions-item label="附件" :span="6">
            <file-upload-list ref="fileUploadList" :fileList="problemDes.faultCommonFiles"></file-upload-list>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item v-for="(item, index) of carData" :key="index" :label="item.label">
            {{ item.content }}
          </el-descriptions-item> -->
        </el-descriptions>
        <!-- 根因分析 -->
        <div v-if="problemDes.rootCauseAnalysis?.length > 0">
          <div class="tableSubHeader">
            <p>根因分析</p>
          </div>
          <el-table
            style="width: 100%"
            ref="tableRef"
            border
            stripe
            :data="problemDes.rootCauseAnalysis"
            class="rootCauseAnalysisTable"
          >
            <el-table-column
              label="序号"
              width="50px"
              type="index"
              align="center"
            >
            </el-table-column>
            <el-table-column label="根因分析" prop="solution">
            </el-table-column>
            <el-table-column label="附件" prop="fileData">
              <template slot-scope="{ row }">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="row.fileData"
                ></file-upload-list>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="problemDes.permanentSolution?.length > 0">
          <div class="tableSubHeader">
            <p>永久方案</p>
          </div>
          <el-table
              ref="tableRef"
              :border="true"
              stripe
              :data="problemDes.permanentSolution"
              class="permanentSolutionTable"
              style="width: 100%"
            >
              <el-table-column
                label="序号"
                width="50px"
                type="index"
                align="center"
              >
              </el-table-column>
              <el-table-column label="永久方案" prop="solution">
              </el-table-column>
              <el-table-column label="附件" prop="fileData">
                <template slot-scope="{ row }">
                  <file-upload-list
                    ref="fileUploadList"
                    :fileList="row.fileData"
                  ></file-upload-list>
                </template>
              </el-table-column>
            </el-table>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import Translate from "@/components/translate";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
export default {
  name: "problemDes",
  components: { Translate, fileUploadTips },
  data() {
    return {
      activeNames: ["des"], // 全部展开
      form: {},
    };
  },
  props: {
    problemDes: {
      type: [Array, Object],
      // default:() => []
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    formRules() {
      const isRequired = !this.authStatus;
      return {
        questionContent: [
          {
            required: isRequired,
            message: "故障现象描述不能为空",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    // 翻译
    baseClassConfig() {
      return {
        labelClassName: `translate-label ${
          this.authStatus ? "" : "lable-required"
        }`,
        contentClassName: "translate-content",
      };
    },
    otrherClassName() {
      return {
        labelClassName: `transparent-label`,
        contentClassName: `descriptions-content`,
      };
    },
  },
  async created() {
    this.getProblemDesData();
  },
  methods: {
    // 获取数据
    getProblemDesData() {
      if (this.problemDes) {
        this.form = this.problemDes;
      }
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:problemDes", this.form);
    },
    validateForm() {
      return this.$refs["descForm"]
        .validate()
        .then(() => ({ isValid: true, object: null }))
        .catch((errors) => ({ isValid: false, object: errors }));
    },
  },
};
</script>
<style scoped>
::v-deep .el-table.rootCauseAnalysisTable .el-table__cell .cell,
::v-deep .el-table.permanentSolutionTable .el-table__cell .cell {
  white-space: normal;
  word-break: break-word;
}
</style>
